var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 294"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 4.5L4 0.5L8 4.5H0Z",
    fill: "#495057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 7.5L4 11.5L8 7.5H0Z",
    fill: "#495057"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingIcon);
export default __webpack_public_path__ + "static/media/sorting_icon.ca2cb12f67bd81b3676b0558f640c9ab.svg";
export { ForwardRef as ReactComponent };